import { Button } from "@fluentui/react-components";

import { useTeamsNavigation } from "../../../../hooks/use-teams-navigation.js";
import { BaseModal } from "../base-modal.jsx";
import type { SharedModalProps } from "../base-modal.jsx";

interface InviteModalEnterpriseVariantProps extends SharedModalProps {
  channelId: string | undefined;
  teamId: string;
  tenantId: string;
  title: string;
}

export const InviteModalEnterpriseVariant = ({
  channelId,
  onClose,
  teamId,
  tenantId,
  title,
}: InviteModalEnterpriseVariantProps) => {
  const { isLoading, navigateToTeam } = useTeamsNavigation(
    onClose ? { onCompleted: onClose } : undefined
  );

  const handleOpenTeam = async () => {
    if (!channelId) {
      return;
    }

    await navigateToTeam({
      channelId,
      teamId,
      tenantId,
    });
  };

  return (
    <BaseModal
      actionComponent={
        <Button
          appearance="primary"
          disabled={!channelId || isLoading(teamId)}
          onClick={handleOpenTeam}
        >
          Open team
        </Button>
      }
      {...(onClose ? { onClose } : {})}
      title={title}
    >
      <p>
        Enterprise clients have to manage office membership through Microsoft
        Teams team members. Open the team in Microsoft Teams, then select Manage
        team from the team menu to manage members.
      </p>
    </BaseModal>
  );
};
